export const ADD_RSVP = 'ADD_RSVP';
export const REMOVE_RSVP = 'REMOVE_RSVP';
export const EDIT_EVENT = 'EDIT_EVENT';
export const CREATE_EVENT = 'CREATE_EVENT';
export const CLEAR_EVENTS = 'CLEAR_EVENTS';
export const GET_ALL_RSVPS = 'GET_ALL_RSVPS';
export const GET_ONE_EVENT = 'GET_ONE_EVENT';
export const GET_ALL_EVENTS = 'GET_ALL_EVENTS';
export const GET_SINGLE_RSVPS = 'GET_SINGLE_RSVPS';
export const EVENT_ADD_KEYS_FOR_RADIUS = 'EVENT_ADD_KEYS_FOR_RADIUS';
export const EVENT_CLEAR_RADIUS = 'EVENT_CLEAR_RADIUS';



// WEBPACK FOOTER //
// ./src/constants/event.js